<template><div><h1>VUX V2.6.0 released</h1>
<h2><a href="/en/components/calendar.html">Calendar</a></h2>
<ul><li>[feature] support prop:show-popup-header</li>
</ul>
<h2><a href="/en/components/checker.html">Checker</a></h2>
<ul><li>[fix] Fix event:on-change do not fire when using :value binding instead of v-model #1945</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] fix i18n for cancel_text confirm_text</li>
</ul>
<h2><a href="/en/components/grid.html">Grid</a></h2>
<ul><li>[change] prop:rows is deprecated #1971</li>
</ul>
<h2><a href="/en/components/inline-calendar.html">InlineCalendar</a></h2>
<ul><li>[feature] (beta) Support prop:marks to style specified date item</li>
<li>[fix] fix i18n for days</li>
</ul>
<h2><a href="/en/components/load-more.html">LoadMore</a></h2>
<ul><li>[fix] fix `tip` is empty and `show-loading` is `false`, the background color is not correct</li>
<li>[feature] support less variable @load-more-tip-background-color</li>
</ul>
<h2><a href="/en/components/panel.html">Panel</a></h2>
<ul><li>[enhance] support list prop:fallbackSrc #1923</li>
</ul>
<h2><a href="/en/components/popup-radio.html">PopupRadio</a></h2>
<ul><li>[fix] fix placeholder logic #1964</li>
</ul>
<h2><a href="/en/components/swiper.html">Swiper</a></h2>
<ul><li>[enhance] support fallbackImg for prop:list #1923</li>
</ul>
<h2><a href="/en/components/x-dialog.html">XDialog</a></h2>
<ul><li>[fix] fix body still scrolls when scrolling on dialog</li>
</ul>
<h2><a href="/en/components/x-img.html">XImg</a></h2>
<ul><li>[fix] re-initialize when src is changed #1901</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.6.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.6.0-132.vue?29839870